<template>
  <v-card color="indigo darken-4" dark style="height:100%">
    <v-card-title primary-title class="mb-0">
      <h3>Funding Released</h3>
    </v-card-title>
    <v-card-text>
      <v-layout wrap>
        <v-flex xs12 md6>
          <h3 class="subtitle-1">Successful Enquiries</h3>
        </v-flex>
        <v-flex xs12 md6>
          <div class="display-1">{{ enquiries['FUNDING RELEASED'] }}</div>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 md6>
          <h3 class="subtitle-1">Value</h3>
        </v-flex>
        <v-flex xs12 md6>
          <div class="display-1">{{ amountFunded | currency }}</div>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ['enquiries', 'amountFunded']
};
</script>

<style scoped>
.subtitle-1 {
  padding-top: 3px;
}

.display-1 {
  text-align: right;
}
</style>
